import actionsCreator from 'helpers/actionCreator';
import { actionTypes } from '../../actionTypes';
import type { DisconnectUserAction } from './types';

const disconnectUser = (): DisconnectUserAction => actionsCreator.createAction(actionTypes.DISCONNECTED);

export const disconnectionActions = {
  disconnectUser,
};
